var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.4291,
    y: 25.6906,
    fill: "#FF5A00",
    width: 27.0617,
    height: 48.6189
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB001B",
    d: "M38.2306,50c0-9.8779,4.6437-18.6449,11.7694-24.3094 c-5.2442-4.1233-11.8595-6.6153-19.0753-6.6153C13.8311,19.0753,0,32.9063,0,50s13.8311,30.9247,30.9247,30.9247 c7.2158,0,13.8311-2.492,19.0753-6.6153C42.8643,68.725,38.2306,59.8779,38.2306,50z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79E1B",
    d: "M100,50c0,17.0937-13.8311,30.9247-30.9247,30.9247 c-7.2158,0-13.8311-2.492-19.0753-6.6153C57.2158,68.6349,61.7694,59.8779,61.7694,50S57.1257,31.3551,50,25.6906 c5.2342-4.1233,11.8495-6.6153,19.0652-6.6153C86.1689,19.0753,100,32.9964,100,50z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.880867b1.svg";
export { ForwardRef as ReactComponent };